// extracted by mini-css-extract-plugin
export var compactFilters = "_dd-4";
export var detailImage = "_dd-1";
export var dropdownContainer = "_dd-2";
export var imageContainer = "_dd-0";
export var selectedCard = "_dd-3";